<div class="container-modal-lateral">
  <div>
    <span class="title-modal-lateral">Filtrar</span>
    <div class="filtro">
      <app-select-one
        class="width-100"
        heightFormField="36px"
        placeholder="Selecione a atividade"
        [listaInput]="atividadeOpcoes"
        [itemSelecionado]="filtro.atendimento"
        (selecionarItem)="filtro.atendimento = $event"
        backgroundColor="rgba(221, 188, 255, 0.1)"
        label="Atendimentos"
        campo="nome"
        colorLabel="black"
      ></app-select-one>
      <app-select-one
        class="width-100"
        heightFormField="36px"
        placeholder="Selecione a atividade"
        [listaInput]="atividadeOpcoes"
        [itemSelecionado]="filtro.sessao"
        (selecionarItem)="filtro.sessao = $event"
        backgroundColor="rgba(221, 188, 255, 0.1)"
        label="Sessão"
        campo="nome"
        colorLabel="black"
      ></app-select-one>
    </div>
  </div>


<div class="botoes-modal-lateral">
  <app-button-padrao
    width="100%"
    label="Filtrar"
    backgroundColor="var(--verde-padrao)"
    color="white"
    (buttonClick)="filtrar()">
  </app-button-padrao>
  <app-button-padrao
    width="100%"
    label="Cancelar"
    backgroundColor="white"
    color="var(--vermelho-padrao)"
    (buttonClick)="cancelar()"
    borderColor="var(--vermelho-padrao)"
    borderStyle="solid"
    borderWidth="1px">
  </app-button-padrao>
</div>
